module.exports = __webpack_public_path__ + "img/smile--green--wink.9bbae633.svg";